// services for user api
import axios from 'axios'
// import global settings
import baseConf from '@/Base'

var instance = axios.create({
  baseURL: baseConf.urlApi,
  timeout: 3000
})


export function  getHome() {
  // devuelve todos los torneos de un usuario, paginados
  return instance.get('/api/get/home/')
}

export function  listarAnunciosBasicos(tipo, num, torneo) {
  // devuelve todos los torneos de un usuario, paginados
  return instance.get('/api/listar/anuncios/' + tipo + '/' + num + '/' + torneo + '/')
}

export function  listarAnunciosCompeticion(tipo, num, usernameCompetition) {
  // devuelve todos los torneos de un usuario, paginados
  return instance.get('/api/listar/anuncios/' + tipo + '/' + num + '/' + usernameCompetition + '/')
}

export function  listGMnews(page) {
  // devuelve todos los torneos de un usuario, paginados
  return instance.get('/api/gm/novedades/?page=' + page)
}

export function  listDonadores(page) {
  // devuelve todos los torneos de un usuario, paginados
  return instance.get('/api/donadores/lista/?page=' + page)
}

export function  listaTopOrganizers() {
  // devuelve todos los torneos de un usuario, paginados
  return instance.get('/api/top/organizers/')
}
